module.exports = __webpack_public_path__ + "static/img/A175.a4915238.jpg";